import { COLORS } from './colors.js';
import { TYPOGRAPHY } from './typography.js';
import { SPACING, BORDERS } from './spacing.js';
import { SHADOWS } from './shadows.js';
export * from './colors.js';
export * from './typography.js';
export * from './spacing.js';
export * from './shadows.js';
const TODOS_OS_TOKENS = {
    ...COLORS,
    ...TYPOGRAPHY,
    ...SPACING,
    ...BORDERS,
    ...SHADOWS,
};
const ID_ESTILO_TOKENS = 'pg-design-tokens';
/**
 * Gera o bloco CSS de variáveis customizadas (`--pg-<token>`) a partir
 * dos tokens TypeScript — única fonte de verdade compartilhada entre
 * código e estilo. Nenhum componente declara uma cor/espaçamento
 * "solto"; todos referenciam `var(--pg-<token>)`.
 */
function gerarCssDeTokens() {
    const linhas = Object.entries(TODOS_OS_TOKENS).map(([chave, valor]) => `  --pg-${chave}: ${valor};`);
    return `:root {\n${linhas.join('\n')}\n}`;
}
/**
 * Injeta os tokens como variáveis CSS globais em `document.head`.
 * Chamado uma vez pela aplicação consumidora (não por cada componente
 * individualmente — componentes apenas referenciam `var(--pg-*)` e
 * confiam que a aplicação já chamou isto na inicialização).
 * Chamar mais de uma vez é seguro (idempotente: substitui o `<style>`
 * anterior em vez de duplicar).
 */
export function injetarTokensGlobais(doc = document) {
    const existente = doc.getElementById(ID_ESTILO_TOKENS);
    if (existente)
        existente.remove();
    const estilo = doc.createElement('style');
    estilo.id = ID_ESTILO_TOKENS;
    estilo.textContent = gerarCssDeTokens();
    doc.head.appendChild(estilo);
}
//# sourceMappingURL=index.js.map